var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52644 12C9.73558 12 9.82212 11.8185 9.82212 11.6219C9.82212 11.569 9.82212 11.5236 9.8149 11.4707L9.19471 7.68998L11.8125 5.01323C11.9062 4.91493 12 4.78639 12 4.65028C12 4.42344 11.7692 4.3327 11.5962 4.30246L7.97596 3.75047L6.35337 0.310019C6.28846 0.166352 6.16587 0 6 0C5.83413 0 5.71154 0.166352 5.64663 0.310019L4.02404 3.75047L0.403846 4.30246C0.223558 4.3327 0 4.42344 0 4.65028C0 4.78639 0.09375 4.91493 0.180288 5.01323L2.80529 7.68998L2.1851 11.4707C2.17788 11.5236 2.17067 11.569 2.17067 11.6219C2.17067 11.8185 2.26442 12 2.47356 12C2.57452 12 2.66827 11.9622 2.76202 11.9093L6 10.1248L9.23798 11.9093C9.32452 11.9622 9.42548 12 9.52644 12Z",
    fill: "#1C2130"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackStarIcon);
export default __webpack_public_path__ + "static/media/black_star_icon.fe040c4b8219b62ca014c7fb6f095643.svg";
export { ForwardRef as ReactComponent };